export default __webpack_public_path__ + "static/media/promo_bg.4615c81d.jpg";